import React from 'react'
import {FormSelect} from '@/components/ui/form'
import {ControllerRenderProps} from 'react-hook-form'

const deadlines = [
    {
        id: 'Deadline1',
        value: 'Deadline1',
        displayValue: 'January'
    },
    {
        id: 'Deadline2',
        value: 'Deadline2',
        displayValue: 'February'
    },
    {
        id: 'Deadline3',
        value: 'Deadline3',
        displayValue: 'March'
    },
    {
        id: 'Deadline4',
        value: 'Deadline4',
        displayValue: 'April'
    },
    {
        id: 'Deadline5',
        value: 'Deadline5',
        displayValue: 'May'
    },
    {
        id: 'Deadline6',
        value: 'Deadline6',
        displayValue: 'June'
    },
    {
        id: 'Deadline7',
        value: 'Deadline7',
        displayValue: 'July'
    },
    {
        id: 'Deadline8',
        value: 'Deadline8',
        displayValue: 'August'
    },
    {
        id: 'Deadline9',
        value: 'Deadline9',
        displayValue: 'September'
    },
    {
        id: 'Deadline10',
        value: 'Deadline10',
        displayValue: 'October'
    },
    {
        id: 'Deadline11',
        value: 'Deadline11',
        displayValue: 'November'
    },
    {
        id: 'Deadline12',
        value: 'Deadline12',
        displayValue: 'December'
    }
]

interface DeadlineProps {
    label: string
    field: ControllerRenderProps<any, any>
}

const Deadline = ({label, field}: DeadlineProps) => (
    <FormSelect label={label} fieldProps={field} data-testid="deadline-FormSelect">
        <option id="" value=""></option>
        {deadlines.map(({id, value, displayValue}) => (
            <option key={id} id={id} value={value}>
                {displayValue}
            </option>
        ))}
    </FormSelect>
)

export default Deadline
